import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Button": Button, "@mui/material/styles": { styled }, "@mui/material/Dialog": Dialog, "@mui/material/DialogTitle": DialogTitle, "@mui/material/DialogContent": DialogContent, "@mui/material/DialogActions": DialogActions, "@mui/material/IconButton": IconButton, "@mui/icons-material/Close": CloseIcon, "@mui/material/Typography": Typography } } });
export default ClientProvider;
